import React from 'react';
import QuizWizard from '../components/Quiz/QuizWizard';
import TraderQuizShell from './TraderQuizShell';
import '../pages/Landing.css';
import '../components/Quiz/Quiz.css';

/**
 * Public trader profile quiz — progress persisted in localStorage (see quizStorage).
 */
const TraderQuiz = () => {
  return (
    <TraderQuizShell>
      <QuizWizard />
    </TraderQuizShell>
  );
};

export default TraderQuiz;
